import { ButtonApiErrorWrapper } from 'app/components/shared/ButtonApiErrorWrapper'
import { SmartInput } from 'app/components/shared/FormComponents/SmartInput'
import { FormGroup } from 'app/components/shared/FormGroup'
import { Button } from 'app/components/ui/Button'
import { Card } from 'app/components/ui/Card'
import { Form } from 'app/components/ui/Form'
import { Text } from 'app/components/ui/Text'
import { Title } from 'app/components/ui/Title'
import { useResendConfirmUserEmail } from 'app/queries/resendCofirmUserEmail'
import React from 'react'
import styled from 'styled-components'

import {
  adaptFormDataToAPI,
  resendConfirmUserEmailDefaultValues,
  ResendConfirmUserEmailFormData,
  resendConfirmUserEmailValidationSchema,
} from './form'

export const ResendConfirmUserEmailForm = (): JSX.Element => {
  const {
    mutate: executeResendConfirmUserEmail,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useResendConfirmUserEmail()

  const onSubmit = (data: ResendConfirmUserEmailFormData) => {
    return executeResendConfirmUserEmail(adaptFormDataToAPI(data))
  }

  return (
    <Form<ResendConfirmUserEmailFormData>
      defaultValues={resendConfirmUserEmailDefaultValues}
      validationSchema={resendConfirmUserEmailValidationSchema}
      onSubmit={onSubmit}
    >
      <Card shadow padding='2rem'>
        {isSuccess ? (
          <>
            <Title size={4}>Controlla il tuo indirizzo email</Title>
            <Text mt={1}>
              Ti abbiamo inviato le istruzioni per confermare il tuo account.
            </Text>
          </>
        ) : (
          <>
            <EmailFormGroup>
              <SmartInput
                label='Email'
                type='email'
                name='email'
                placeholder='Inserisci la tua email'
              />
            </EmailFormGroup>
            <ButtonApiErrorWrapper
              isError={isError}
              error={error}
              outline
              alignCenter
              customMessage={
                error?.response?.status === 404
                  ? "L'email inserita non è valida"
                  : undefined
              }
            >
              <Button size='lg' type='submit' disabled={isLoading}>
                {isLoading ? 'Caricamento...' : `Reinvia l'email`}
              </Button>
            </ButtonApiErrorWrapper>
          </>
        )}
      </Card>
    </Form>
  )
}

const EmailFormGroup = styled(FormGroup)`
  margin-bottom: 3rem;
`
